<template>
  <div>
    <div class="login-panel">
      <div class="main">
        <div class="banner"></div>
        <p v-if="refreshTipsShow" class="refresh-tips">
          {{$t('redirect', {sec: countdownNum})}}
          <span @click="refresh">{{$t('immediately')}}</span>
        </p>
        <p v-else class="wait">{{$t('wait')}}</p>
      </div>
      <ul class="footer">
        <li>
          <router-link :to="iPath('/termsService')">{{$ct('termsService')}}</router-link>
        </li>
        <li>
          <router-link :to="iPath('/privacyPolicy')">{{$ct('privacyPolicy')}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { post } from '@/utils/ajax'
export default {
  inject: ['iPath'],
  data() {
    return {
      countdownNum: 5,
      refreshTipsShow: false
    }
  },
  mounted() {
    if (this.$route.query.code) {
      this.activeAccount(this.$route.query.code)
    }
  },
  methods: {
    refresh() {
      this.$router.replace(this.iPath('/login'))
    },
    showRefreshTips() {
      this.refreshTipsShow = true
      this.t = setInterval(() => {
        if (this.countdownNum !== 0) {
          this.countdownNum--
        } else {
          this.refresh()
        }
      }, 1000)
    },
    async activeAccount(code) {
      // 假数据
      await post(`/edu/base/activation/${code}`, { code })
      if (status < 400) {
        this.$message.success(this.$t('activated'))
        this.showRefreshTips()
      }
    }
  },
  beforeDestroy() {
    if (this.t) {
      clearInterval(this.t)
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 657px;
  height: 376px;
  background: url('~@/common/image/activtion.png') no-repeat;
  margin: 0 auto 30px auto;
}
.main {
  display: block;
  padding: 80px 0;
}
.wait,
.refresh-tips {
  text-align: center;
}
.refresh-tips {
  span {
    color: #00c4aa;
    cursor: pointer;
  }
}
</style>

<i18n lang="yaml">
en:
  immediately: redirect immediately
  redirect: 'Redirect in {sec}s, or click'
  wait: Wating...
  activated: Account activated
zh-CN:
  immediately: 立即刷新
  redirect: '{sec}秒后自动刷新，或'
  wait: 请稍后...
  activated: 账号激活成功
zh-TW:
  immediately: 立即刷新
  redirect: '{sec}秒后自動刷新，或'
  wait: 請稍後...
  activated: 賬號激活成功
it:
  immediately: reindirizza immediatamente
  redirect: 'Reindirizza tra {sec} s o fai clic'
  wait: In attesa...
  activated: Account attivato
id:
  immediately: alihkan segera
  redirect: 'Mengalihkan dalam {sec} detik, atau klik'
  wait: Menunggu...
  activated: Akun diaktifkan
</i18n>
